<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div>&nbsp;</div>
      <ul class="nav" v-if="isMenuDefault">
        <li class="nav-item">
          <router-link :to="{ name: 'StartPage' }" class="nav-link"><i class="fa fa-home"></i> {{$lang.Menu.Items.StartPage}} </router-link>
        </li>
        <li class="divider"></li>

        <li class="nav-title" v-if="hasRole(this.roles.MENU_SINISTER) || hasRole(this.roles.MENU_INSPECTION) || hasRole(this.roles.MENU_DISTRIBUTION) || hasRole(this.roles.MENU_IMPORTS) || hasRole(this.roles.MENU_LIGHTHOUSE)">
          {{$lang.Menu.Section.Regulation}}
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_SINISTER)">
          <router-link :to="{ name: 'Regulacao' }" class="nav-link" exact><i class="fa fa-file-text-o"></i> {{$lang.Menu.Items.Sinister}} <small>(Autos)</small></router-link>
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_INSPECTION)">
          <router-link :to="{ name: 'Vistoria' }" class="nav-link" exact><i class="fa fa-car"></i> {{$lang.Menu.Items.CarInspection}}</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_DISTRIBUTION)">
          <router-link :to="{ name: 'Distribuicao' }" class="nav-link" exact><i class="fa fa-exchange"></i> {{$lang.Menu.Items.Distribution}} </router-link>
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_IMPORTS)">
          <router-link :to="{ name: 'Importacao' }" class="nav-link" exact><i class="fa fa-cloud-upload"></i> {{$lang.Menu.Items.Imports}} </router-link>
        </li>
         <li class="nav-item" v-if="hasRole(this.roles.MENU_LIGHTHOUSE)">
          <router-link :to="{ name: 'Farol' }" class="nav-link" exact><i class="fa fa-hourglass-end"></i> {{$lang.Menu.Items.Lighthouse}} </router-link>
        </li>
        <li class="divider"></li>

        <li class="nav-title" v-if="hasRole(this.roles.MENU_REPORTS) || hasRole(this.roles.MENU_MONITORING) || hasRole(this.roles.MENU_EXPERTROUTES)">
          {{$lang.Menu.Section.Management}}
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_REPORTS)">
          <a class="nav-link" exact @click="showMenuReport"><i class="fa fa-bar-chart"></i> {{$lang.Menu.Items.Reports}} </a>
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_MONITORING)">
          <router-link :to="{ name: 'Monitoria' }" class="nav-link" exact><i class="fa fa-balance-scale"></i> {{$lang.Menu.Items.Monitoring}} </router-link>
        </li>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_EXPERTROUTES)">
          <router-link :to="{ name: 'Roteirizador' }" class="nav-link" exact><i class="fa fa-map-signs"></i> {{$lang.Menu.Items.ExpertRoutes}} </router-link>
        </li>
        <li class="divider"></li>

        <li class="nav-title" v-if="hasRole(this.roles.MENU_ADMINISTRATION) || hasRole(this.roles.MENU_CONFIGURATION)">
          {{$lang.Menu.Section.Customization}}
        </li>
         <router-link v-if="hasRole(this.roles.MENU_ADMINISTRATION)" tag="li" class="nav-item nav-dropdown" :to="{ path: '/administration'}" disabled>
          <div class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fa fa-shield"></i> {{$lang.Menu.Items.Access.Administration}}</div>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(this.roles.RW_ADM_ACCOUNTS)">
              <router-link :to="{ name: 'Contas' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Accounts}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_ADM_GROUPS)">
              <router-link :to="{ name: 'Grupos' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Groups}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_ADM_PERMISSIONS)">
              <router-link :to="{ name: 'Permissoes' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Permissions}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(this.roles.RW_ADM_LOGS)">
              <router-link :to="{ name: 'AdminitrativeLog' }" class="nav-link" exact><i class="fa fa-caret-right"></i> {{$lang.Menu.Items.Access.Log}}</router-link>
            </li>
          </ul>
        </router-link>
        <li class="nav-item" v-if="hasRole(this.roles.MENU_CONFIGURATION)">
          <router-link :to="{ name: 'Configuracoes' }" class="nav-link" exact><i class="fa fa-cogs"></i> {{$lang.Menu.Items.Configuration.Settings}}</router-link>
        </li>
        <li class="divider"></li>
        <li class="pt-5">&nbsp;</li>
      </ul>
      <ul class="nav" v-if="isMenuReport">
        <li class="nav-item">
          <a class="nav-link"  @click="showMenuDefault"><i class="iocn icon-arrow-left"></i> {{$lang.Menu.Common.Back}}</a>
        </li>
        <li class="nav-title">
          {{$lang.Menu.Section.Reports}}
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Relatorios' }" class="nav-link" exact><i class="fa fa-caret-right"></i> Rel. Sinistros </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="{ name: 'Relatorios' }" class="nav-link" exact><i class="fa fa-caret-right"></i> SLA </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import SidebarConfig from './SidebarConfig.vue'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'AppSidebar',
  mixins: [ AccountMixin, PermissionMixin ],
  data () {
    return {
      roles: Roles,
      isMenuDefault: true,
      isMenuReport: false
    }
  },
  mounted () {
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
      })
  },
  components: {
    SidebarConfig
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    },
    showMenuReport () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = false
      this.isMenuReport = true
    },
    showMenuDefault () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = true
      this.isMenuReport = false
    },
    RemoveMinimizedSidebar: function () {
      document.body.classList.remove('sidebar-minimized')
      window.scrollTo(0, 0)
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/containers/layout/Sidebar.vue